export const THEME_STORAGE_KEY = 'revivepay-ui-preferences';

export const DEFAULT_THEME_PREFERENCES = {
  mode: 'light',
  paletteId: 'revive',
  borderRadius: 'medium',
};

export const loadThemePreferences = () => {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY);
    if (!raw) return { ...DEFAULT_THEME_PREFERENCES };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_THEME_PREFERENCES, ...parsed };
  } catch {
    return { ...DEFAULT_THEME_PREFERENCES };
  }
};

export const saveThemePreferences = (preferences) => {
  localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(preferences));
};
